"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("@mui/material/styles");
var Box_1 = require("@mui/material/Box");
var Button_1 = require("@mui/material/Button");
var Modal_1 = require("@mui/material/Modal");
var react_1 = require("react");
var TextareaAutosize_1 = require("@mui/base/TextareaAutosize");
var TextField_1 = require("@mui/material/TextField");
var CloudUpload_1 = require("@mui/icons-material/CloudUpload");
var Stack_1 = require("@mui/material/Stack");
var Sponsor_1 = require("../models/Sponsor");
var Toast_1 = require("../shared/utilities/Toast");
var style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
var blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
};
var grey = {
    50: '#f6f8fa',
    100: '#eaeef2',
    200: '#d0d7de',
    300: '#afb8c1',
    400: '#8c959f',
    500: '#6e7781',
    600: '#57606a',
    700: '#424a53',
    800: '#32383f',
    900: '#24292f',
};
var Textarea = styles_1.styled(TextareaAutosize_1.TextareaAutosize)(function (_a) {
    var theme = _a.theme;
    return "\n    width: 100%;\n    font-family: IBM Plex Sans, sans-serif;\n    font-size: 0.875rem;\n    resize: 'vertical';\noverflow: 'auto';\n    font-weight: 400;\n    line-height: 1.5;\n    padding: 12px;\n    border-radius: 12px 12px 0 12px;\n    color: " + (theme.palette.mode === 'dark' ? grey[300] : grey[900]) + ";\n    background: " + (theme.palette.mode === 'dark' ? grey[900] : '#fff') + ";\n    border: 1px solid " + (theme.palette.mode === 'dark' ? grey[700] : grey[200]) + ";\n    box-shadow: 0px 2px 2px " + (theme.palette.mode === 'dark' ? grey[900] : grey[50]) + ";\n\n    &:hover {\n      border-color: " + blue[400] + ";\n    }\n\n    &:focus {\n      border-color: " + blue[400] + ";\n      box-shadow: 0 0 0 3px " + (theme.palette.mode === 'dark' ? blue[500] : blue[200]) + ";\n    }\n\n    // firefox\n    &:focus-visible {\n      outline: 0;\n    }\n  ";
});
var VisuallyHiddenInput = styles_1.styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
var SponsorModal = react_1.forwardRef(function (props, ref) {
    var _a = Toast_1.default(), showErrorMessage = _a.showErrorMessage, showSuccessMessage = _a.showSuccessMessage;
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var _c = React.useState(''), id = _c[0], setId = _c[1];
    var _d = React.useState(''), name = _d[0], setName = _d[1];
    var _e = React.useState(''), phoneNumber = _e[0], setPhoneNumber = _e[1];
    var _f = React.useState(''), email = _f[0], setEmail = _f[1];
    var _g = React.useState(''), website = _g[0], setWebsite = _g[1];
    var _h = React.useState(''), description = _h[0], setDescription = _h[1];
    var _j = React.useState(''), logo = _j[0], setLogo = _j[1];
    var _k = React.useState(undefined), file = _k[0], setFile = _k[1];
    var _l = React.useState(false), isInvalid = _l[0], setIsInvalid = _l[1];
    var _m = React.useState(false), isMobile = _m[0], setIsMobile = _m[1];
    //choose the screen size 
    var handleResize = function () {
        if (window.innerWidth < 720) {
            setIsMobile(true);
        }
        else {
            setIsMobile(false);
        }
    };
    var handleOpen = function (sponsor) {
        setOpen(true);
        setId(sponsor.SponsorId);
        setName(sponsor.SponsorName);
        setPhoneNumber(sponsor.SponsorPhoneNumber);
        setEmail(sponsor.SponsorEmail);
        setWebsite(sponsor.SponsorWebsite);
        setDescription(sponsor.SponsorDescription);
        setLogo(sponsor.SponsorLogoLocation);
        setFile(undefined);
        setIsInvalid(sponsor.SponsorId !== '');
        window.addEventListener("resize", handleResize);
        handleResize();
    };
    var handleClose = function () {
        setOpen(false);
        window.removeEventListener("resize", handleResize);
    };
    var handleNameChange = function (e) {
        setName(e.target.value);
    };
    var handlePhoneNumberChange = function (e) {
        setPhoneNumber(e.target.value);
    };
    var handleEmailChange = function (e) {
        setEmail(e.target.value);
    };
    var handleWebsiteChange = function (e) {
        setWebsite(e.target.value);
    };
    var handleDescriptionChange = function (e) {
        setDescription(e.target.value);
    };
    var handleFileChange = function (e) {
        var file = e.target.files[0];
        setLogo(URL.createObjectURL(file));
        setFile(file);
    };
    react_1.useImperativeHandle(ref, function () { return ({
        handleOpen: handleOpen
    }); });
    return (React.createElement(Modal_1.default, { open: open, onClose: handleClose, "aria-labelledby": "parent-modal-title", "aria-describedby": "parent-modal-description" },
        React.createElement(Box_1.default, { sx: __assign(__assign({}, style), { width: isMobile ? '90%' : '50%', overflowY: 'auto', maxHeight: '85%' }) },
            React.createElement(TextField_1.default, { id: "outlined-basic", margin: "normal", label: "Sponsor Name", variant: "outlined", fullWidth: true, value: name, onChange: handleNameChange, error: isInvalid && name === "", helperText: isInvalid && name === "" ? 'Sponsor name is required' : '', inputProps: { maxLength: 100 } }),
            React.createElement(TextField_1.default, { id: "outlined-basic", margin: "normal", label: "Phone Number", variant: "outlined", fullWidth: true, value: phoneNumber, onChange: handlePhoneNumberChange, inputProps: { maxLength: 50 } }),
            React.createElement(TextField_1.default, { id: "outlined-basic", margin: "normal", label: "Email", variant: "outlined", fullWidth: true, value: email, onChange: handleEmailChange, inputProps: { maxLength: 100 } }),
            React.createElement(TextField_1.default, { id: "outlined-basic", margin: "normal", label: "Website", variant: "outlined", fullWidth: true, value: website, onChange: handleWebsiteChange, inputProps: { maxLength: 250 } }),
            React.createElement(TextField_1.default, { label: "Description", multiline: true, fullWidth: true, rows: 8, variant: "outlined", margin: "normal", value: description, onChange: handleDescriptionChange, error: isInvalid && description === "", helperText: isInvalid && description === "" ? 'Sponsor description is required' : '' }),
            React.createElement(Button_1.default, { component: "label", variant: "contained", startIcon: React.createElement(CloudUpload_1.default, null) },
                "Upload Sponsor Logo",
                React.createElement(VisuallyHiddenInput, { type: "file", onChange: handleFileChange })),
            React.createElement("br", null),
            logo !== '' && logo !== null &&
                React.createElement("a", { href: logo, download: true }, "View Logo"),
            React.createElement("br", null),
            React.createElement(Stack_1.default, { spacing: 2, direction: "row", justifyContent: "flex-end" },
                React.createElement(Button_1.default, { variant: "outlined", onClick: function () {
                        handleClose();
                    } }, "Cancel"),
                React.createElement(Button_1.default, { variant: "contained", onClick: function () {
                        if (description.trim() === '' || name.trim() === '') {
                            setIsInvalid(true);
                            showErrorMessage('Sponsor information is not valid!');
                            return;
                        }
                        var sponsor = new Sponsor_1.SponsorModel();
                        sponsor.SponsorId = id;
                        sponsor.SponsorDescription = description;
                        sponsor.SponsorEmail = email;
                        sponsor.SponsorLogoLocation = logo;
                        sponsor.SponsorName = name;
                        sponsor.SponsorPhoneNumber = phoneNumber;
                        sponsor.SponsorWebsite = website;
                        if (file != undefined) {
                            var reader_1 = new FileReader();
                            reader_1.readAsDataURL(file);
                            reader_1.onload = function () {
                                if (reader_1.result != null) {
                                    console.log('file name', file.name);
                                    props.upsertSponsor(sponsor, reader_1.result.toString().split('base64,')[1], file.name);
                                }
                            };
                            reader_1.onerror = function (error) {
                                //TODO: log error on all of them
                                console.log('Error: ', error);
                            };
                        }
                        else {
                            props.upsertSponsor(sponsor, null, null);
                        }
                        handleClose();
                    } }, "Confirm")))));
});
exports.default = SponsorModal;
//# sourceMappingURL=SponsorModal.js.map